import * as React from 'react'

const InfoIconBlack = (props: any) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_d)">
      <circle cx="9" cy="7" r="6.6" fill="#FFFAFA" stroke="black" strokeWidth="0.8" />
      <path
        d="M9.52 10H8.464V5.976H9.52V10ZM8.992 5.28C8.816 5.28 8.664 5.22133 8.536 5.104C8.41333 4.98133 8.352 4.83467 8.352 4.664C8.352 4.48267 8.41333 4.33333 8.536 4.216C8.664 4.09867 8.816 4.04 8.992 4.04C9.17333 4.04 9.32533 4.10133 9.448 4.224C9.57067 4.34133 9.632 4.488 9.632 4.664C9.632 4.83467 9.57067 4.98133 9.448 5.104C9.32533 5.22133 9.17333 5.28 8.992 5.28Z"
        fill="black"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="-50%"
        y="-50%"
        width="200%"
        height="200%"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
)

const InfoIconWhite = (props: any) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_d)">
      <circle cx="9" cy="7" r="6.6" fill="#007F7C" stroke="white" strokeWidth="0.8" />
      <path
        d="M9.52 10H8.464V5.976H9.52V10ZM8.992 5.28C8.816 5.28 8.664 5.22133 8.536 5.104C8.41333 4.98133 8.352 4.83467 8.352 4.664C8.352 4.48267 8.41333 4.33333 8.536 4.216C8.664 4.09867 8.816 4.04 8.992 4.04C9.17333 4.04 9.32533 4.10133 9.448 4.224C9.57067 4.34133 9.632 4.488 9.632 4.664C9.632 4.83467 9.57067 4.98133 9.448 5.104C9.32533 5.22133 9.17333 5.28 8.992 5.28Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="-50%"
        y="-50%"
        width="200%"
        height="200%"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
)

export { InfoIconBlack, InfoIconWhite }
